import React from 'react';
import ReactDOM from 'react-dom/client';
import AOS from 'aos';
import GLightbox from 'glightbox';
import Swiper from 'swiper/bundle';
import PureCounter from '@srexi/purecounterjs';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';
import 'swiper/css/bundle';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import './assets/css/main.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set up global window objects for libraries
window.AOS = AOS;
window.GLightbox = GLightbox;
window.Swiper = Swiper;
window.PureCounter = PureCounter;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
